import axios from "axios";
import { getAuth, signOut as firebaseSignOut, sendPasswordResetEmail } from "firebase/auth";

// Function to sign out the user
export const signOutUser = async () => {
  const auth = getAuth();
  try {
    await axios({
      method: "post",
      url: `${process.env.REACT_APP_SPL_URL}/signout`,
      withCredentials: true, // This ensures cookies are sent with the request
    });
    await firebaseSignOut(auth);
    // console.log("User signed out successfully");
  }
  catch (error) {
    console.error("Error signing out: ", error);
  }
};

export const passwordResetRequest = async (email: string) => {
  const auth = getAuth();
  const actionCodeSettings = {
    url: window.location.origin,
    handleCodeInApp: false,
  };

  try {
    await sendPasswordResetEmail(auth, email, actionCodeSettings);
    return true;
  }
  catch (error) {
    console.error("Password reset error:", error);
    return false;
  }
};
